// extracted by mini-css-extract-plugin
export default {"exif_table":"Style_exif_table__qLX8j"};